export type ErrorDetailType = {
  [key: string]: string | ErrorDetailType;
};

/**
 * 错误码列表
 * https://l8jshxfw5fs.jp.larksuite.com/wiki/A6YzwCBiHif0ZVkIeZLjV8REp49
 */

export const ERROR_DETAIL: ErrorDetailType = {
  'links is empty': 'errors.detail.link_empty',
  'Can not update vector_storage, embeddings_model, faq_vector_storage': 'errors.detail.cannot_update',
  'answer is too long': 'errors.detail.answer_long',
  'question is required': 'errors.detail.question_required',
  'Sorry, something went wrong.Please try again later': 'errors.detail.something_wrong',
  'The URL may not accessible or the URL format is incorrect.Error happend for': 'errors.detail.url_error',
  'Fail to get domain title and description.Please check the URL and try again': 'errors.detail.fail_to_get',
  'Unsupport single page website,coming soon': 'errors.detail.unsupport',
  'maximum limit exceeded': 'errors.detail.apikey_limit',
  'AI not exist': 'errors.detail.ai_not_exist',
  'Limit Exceeded.Please upgrade your package': 'errors.detail.package_limit',
  'Dataset is frozen': 'errors.detail.dataset_frozen',
  'FAQs not found': 'errors.detail.faqs_not_found',
  'faq question': 'errors.detail.faq_question_exists',

  // 第二次调整
  'Invalid Parameter': 'errors.detail.invalid_parameter',
  'The dataset is frozen': 'errors.detail.dataset_frozen',
  'Unsupported.': 'errors.detail.unsupported',
  'AI not found': 'errors.detail.ai_not_exist',
  'Access Denied: You are not authorized to access this API.': 'errors.detail.access_denied',
  'Access Denied: You must be logged in to access this API.': 'errors.detail.access_denied',
  'Operation Failed.': {
    'Dataset is connected to ai': 'errors.detail.connected',
    'Dataset already bound to ai': 'errors.detail.rebind',
    'Dataset not bound to ai': 'errors.detail.unbind',
    'Dataset not found': 'errors.detail.dataset_not_found',
    'Too many files, please limit the number of files to': 'errors.detail.upload_limit',
    'File size exceeds the limit': 'errors.detail.upload_size_limit',
    'Empty file': 'errors.detail.file_empty',
    'File extension not allowed': 'errors.detail.file_not_allwoed',
    'The answer is too long': 'errors.detail.answer_too_long',
    'Question exists': 'errors.detail.question_exists',
    'Only Excel files are allowed': 'errors.detail.only_excel',
    'Excel file parsing failed': 'errors.detail.parse_failed',
    'Read file is empty. Or maybe the file is not supported': 'errors.detail.excel_empty',
    'File is too large for analysis': 'errors.detail.file_large',
    'Upload a file before create question': 'errors.detail.upload_before',
    'Message already exists': 'errors.detail.message_exists',
    'Invalid URL. Please check the URL and try again': 'errors.detail.invalid_url',
    'Robot name existed': 'errors.detail.name_existed',
    'Robot name is required': 'errors.detail.name_required',
    'Robot url is required': 'errors.detail.url_required',
    'Invalid dataset id': 'errors.detail.invalid_dataset_id',
    "Dataset has other AI. Don't allow to delete.": 'errors.detail.not_allow_delete',
    'Invalid config key': 'errors.detail.key_error',
    'Invalid max questions value': 'errors.detail.invalid_max_questions',
    'Invalid config value': 'errors.detail.invalid_config_value',
    'The maximum key limit exceeded': 'errors.detail.max_key_limit_exceeded',
    'User not found or already verified': 'errors.detail.user_not_found_or_verified',
    'The source key already exists': 'errors.detail.source_field_exist',
    'The target value already exists': 'errors.detail.target_field_exist',
    'Please delete the child nodes first': 'errors.detail.del_faq_node_first',
    ROLE_MAX_USERS_LIMITTED: 'adminConsole.tip.ROLE_MAX_USERS_LIMITTED',
  },
  'No files found in the Lark share URLs provided': 'errors.integrations.no_files_found',
  'Duplicated folder': 'errors.integrations.duplicated_folder',
  'plan exists for current period': 'errors.detail.plan_exists',
  'Message quota exceeded': 'errors.detail.message_quota_exceeded',
  'Bot quota exceeded': 'errors.detail.bot_quota_exceeded',
  'Web page learning quota exceeded': 'errors.detail.web_page_quota_exceeded',
  'Multi-modal parsing quota exceeded': 'errors.detail.multi_modal_parsing_quota_exceeded',
  'Unable to send messages during this time period': 'errors.detail.message_quota_time_limit',
  "This bot's dedicated message quota has been used up": 'errors.detail.message_quota_used_up',
  'is already active in another group.': 'tag.tag_already_exist',
  'More than one user found.': 'access.transfer.more_than_one_user_found',
  'You already have an active subscription': 'subscription.messages.alreadyActive',
  'You already have a scheduled subscription pending': 'subscription.messages.alreadyScheduled',
  'Password must contain at least': 'reset_password.password_requirements',
};
